export default "__VITE_ASSET__BrTSn$XI__"